import { Component, OnInit } from '@angular/core';
import { confirm } from 'devextreme/ui/dialog';
import * as _ from 'lodash';
import { BsModalService } from 'ngx-bootstrap/modal';
import { AppInformationService, RAFUnitOfWork } from 'src/app/core/core.module';
import { JobType, TimeCategory } from 'src/app/core/data/entities';
import { InputDialogComponent, SharedModule } from 'src/app/shared/shared.module';
import { TimeCategoryDialogComponent } from '../time-category-dialog/time-category-dialog.component';
import { JobTypeDialogComponent } from '../job-type-dialog/job-type-dialog.component';

@Component({
    selector: 'app-table-edit',
    templateUrl: './table-edit.component.html',
    styleUrls: ['./table-edit.component.scss'],
    standalone: false
})
export class TableEditComponent implements OnInit {
    filter: any = { table: 'Time Categories' };
    tables = ['Time Categories', 'Job Types'];
    entities: any;
    maxDisplayOrder: number;

    onToolbarPreparing = SharedModule.onToolbarPreparing;

    constructor(private uow: RAFUnitOfWork, private modalService: BsModalService, private appInfo: AppInformationService) {}

    async ngOnInit() {
        await this.getData();
    }

    onCellPrepared(e) {
        if (this.filter.table === 'Job Types') {
            if (e.rowType === 'data') {
                if (e.data.color) {
                    if (e.column.dataField === 'color') e.cellElement.style.backgroundColor = e.data.color;
                }
            }
        }
    }

    async getData() {
        switch (this.filter.table) {
            case 'Time Categories': {
                this.entities = await this.uow.getActiveTimeCategories();
                break;
            }
            case 'Job Types': {
                this.entities = await this.uow.getActiveJobTypes();
                break;
            }
        }

        if (!this.entities || this.entities.length === 0) {
            this.maxDisplayOrder = 1;
            this.entities = [];
        } else {
            this.maxDisplayOrder = (_.maxBy(this.entities, 'displayOrder')?.displayOrder ?? this.entities.length) + 1;
        }
    }

    async selectionChanged(e) {
        await this.getData();
    }

    onReorder = async (e) => {
        var visibleRows = e.component.getVisibleRows(),
            toIndex = this.entities.indexOf(visibleRows[e.toIndex].data),
            fromIndex = this.entities.indexOf(e.itemData);

        this.entities.splice(fromIndex, 1);
        this.entities.splice(toIndex, 0, e.itemData);

        this.updateDisplayOrder(this.entities);
        this.sort(this.entities);
        await this.uow.commit();
    };

    updateDisplayOrder(rows: any[]) {
        rows.forEach((row, index) => {
            if (row.displayOrder !== index + 1) row.displayOrder = index + 1;
        });
    }

    sort(rows: any[]) {
        rows.sort((a, b) => (a.displayOrder || 9999) - (b.displayOrder || 9999));
    }

    async rowDoubleClick(e) {
        await this.openSelection(e.data);
    }

    async openSelection(selectedRow?: any) {
        switch (this.filter.table) {
            case 'Time Categories': {
                await this.openTimeCategory(selectedRow);
                break;
            }
            case 'Job Types': {
                await this.openJobType(selectedRow);
                break;
            }
            default: {
                this.open(selectedRow);
                break;
            }
        }
    }

    async open(selectedRow?: any) {
        const modalRef = this.modalService.show(InputDialogComponent, {
            class: 'modal-sm',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                dialogHeader: 'Enter New Item',
                dialogPrompt: 'Enter New Item',
                dialogValue: !!selectedRow ? selectedRow.name : null,
                mode: 'text'
            }
        });
        modalRef.content?.result.subscribe(async (result) => {
            if (result.success && result.value) {
                this.appInfo.pleaseWaitShow();
                let entity: any = null;
                // switch (this.filter.table) {
                //     case 'Time Category': {
                //         entity = selectedRow ? await this.uow.timeCategories.byId(selectedRow.id) : this.uow.timeCategories.createEntity();
                //         break;
                //     }
                // }
                if (entity) {
                    entity.name = result.value;
                    if (!entity.displayOrder) entity.displayOrder = this.maxDisplayOrder;
                    await this.uow.commit();
                }
            }
            modalRef.hide();
            await this.getData();
            this.appInfo.pleaseWaitHide();
        });
    }

    async openTimeCategory(timeCategory?: TimeCategory) {
        const modalRef = this.modalService.show(TimeCategoryDialogComponent, {
            class: 'modal-sm',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                timeCategory: timeCategory,
                displayOrder: this.maxDisplayOrder
            }
        });
        modalRef.content?.result.subscribe(async (result) => {
            if (result.success) {
                this.appInfo.pleaseWaitShow();
                await this.getData();
            }
            modalRef.hide();
            this.appInfo.pleaseWaitHide();
        });
    }

    async openJobType(jobType?: JobType) {
        const modalRef = this.modalService.show(JobTypeDialogComponent, {
            class: 'modal-sm',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                jobType: jobType,
                displayOrder: this.maxDisplayOrder
            }
        });
        modalRef.content?.result.subscribe(async (result) => {
            if (result.success) {
                this.appInfo.pleaseWaitShow();
                await this.getData();
            }
            modalRef.hide();
            this.appInfo.pleaseWaitHide();
        });
    }

    async delete(selectedRow: any) {
        const result = await confirm('Are you sure you want to delete this entry?', this.appInfo.settings.company);
        if (!result) return;

        selectedRow.deleted = new Date();
        await this.uow.commit();
        await this.getData();
    }
}
